import React, { useState } from 'react';
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { SearchIcon } from '@primer/octicons-react'
import DocPickerDialog from './DocPickerDialog';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';


const SoundAdminNewView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);

  // Initialize with actual JSON obj.  If not, will get error.
  const [objAttrs, setObjAttrs] = useState({
    id: '',
    name: '',
    description: '',
    docId: null,
    docName: '',
    updatedBy: '',
    timeUpdated: '',
    createdBy: '',
    timeCreated: ''
  });

  const [showDocPickerDialog, setShowDocPickerDialog] = useState(false);

  // UI Functions

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value })
  }

  const handleCreateCancel = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST')
  }

  const handleCreateSubmit = (e) => {
    e.preventDefault();

    // Validate form inputs
    if (!objAttrs.name || objAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
      return;
    } else if (objAttrs.name.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_name") + 50);
      return;

    } else if (objAttrs.description && (objAttrs.description != null) && objAttrs.description.length > 250) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 250);
      return;
    }

    const reqBody = objAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("sounds", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          props.onUIMode('LIST')
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST')
  }


  // Sound select dialog stuff

  const handleDocPicker = (e) => {
    setShowDocPickerDialog(true);
  }

  function handleDocPickerClose() {
    setShowDocPickerDialog(false);
  }

  function handleDocSelect(doc) {

    let tmpAttrs = {};
    tmpAttrs.docId   = doc.id;
    tmpAttrs.docName = doc.name;

    setObjAttrs({ ...objAttrs, ...tmpAttrs});

    setShowDocPickerDialog(false);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Sound")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Asset_type_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          <Container>
            <form>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_Name")}: *</Col>
                <Col>{t("I18N_Description")}: *</Col>
                <Col>{t("I18N_Sound_file")}: *</Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name" value={objAttrs.name}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col>
                  <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'80px', backgroundColor:'white'}}
                            name="description" value={objAttrs.description}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col>
                  <input readOnly className={classes.admin_pages__field_editable} style={{width:'80%'}} name="soundFile" value={objAttrs.docName}
                    onChange={(e) => onAttrsInputChange(e)} />
                  <span onClick={handleDocPicker} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                    <SearchIcon size={14} />
                  </span>
                </Col>
                <Col></Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                <span>{t("I18N_Req_fields")}</span>
              </Row>

              <Row>
                <div display='flex' style={{marginTop:'15px'}}>
                  <Button size="tiny" variant="outline-secondary" className="mb-3"
                    style={{ float: 'left' }}
                    onClick={handleCreateCancel}>
                    {t("I18N_Cancel")}
                  </Button>
                  <Button size="tiny" variant="outline-secondary" className="mb-3"
                    style={{ marginLeft: '15px' }}
                    onClick={handleCreateSubmit}>
                    {t("I18N_Save")}
                  </Button>
                  <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg}
                  </span>
                </div>
              </Row>
            </form>
          </Container>
        </div>

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} style={{ marginTop: '20px' }}>
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
            </div>
          </Form.Group>
        </div>

        <DocPickerDialog
          show={showDocPickerDialog}
          fileTypeFilter={'audio'}
          handleObjSelect={handleDocSelect}
          onClose={handleDocPickerClose}
        />

      </Card>
    </>
  );
}

export default SoundAdminNewView;
